export default "__VITE_ASSET__BgXd9Tgc__"